import { useEffect, useState } from 'react';
import { api } from '../App';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Activity, ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';

const actionClass = (action) => {
  if (action.includes('failed') || action.includes('denied') || action.includes('error')) return 'bg-red-100 text-red-700';
  if (action.includes('external')) return 'bg-purple-100 text-purple-700';
  if (action.includes('send')) return 'bg-green-100 text-green-700';
  if (action.includes('login')) return 'bg-blue-100 text-blue-700';
  return 'bg-slate-100 text-slate-700';
};

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get('/admin/audit-logs?limit=300')
      .then((res) => setLogs(res.data))
      .catch(() => toast.error('Failed to load audit logs'));
  }, []);

  return (
    <div className="space-y-6" data-testid="audit-logs-page">
      <div>
        <h1 className="text-4xl font-bold text-white" style={{fontFamily: 'Space Grotesk'}}>Audit Logs</h1>
        <p className="text-white/80 mt-1">Security and operational trace for logins, sends, admin changes, errors, and external API access.</p>
      </div>

      <Card className="glass-card">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <ShieldCheck className="w-5 h-5 text-blue-600" />
            Recent Events ({logs.length})
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {logs.map((log) => (
            <div key={log.id} className="rounded-lg border bg-white p-4" data-testid={`audit-log-${log.id}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div className="space-y-2">
                  <div className="flex flex-wrap items-center gap-2">
                    <Activity className="w-4 h-4 text-gray-500" />
                    <Badge className={actionClass(log.action)}>{log.action}</Badge>
                    <span className="text-sm font-semibold text-gray-800">{log.entity_type}</span>
                    <code className="text-xs text-gray-500">{log.entity_id}</code>
                  </div>
                  <div className="text-sm text-gray-600">
                    {log.actor_email || 'System'} - {log.company_name || log.company_id || 'No company'} - {new Date(log.created_at).toLocaleString()}
                  </div>
                  {log.details && (
                    <pre className="overflow-x-auto rounded-md bg-gray-900 p-3 text-xs text-gray-100">
                      {JSON.stringify(log.details, null, 2)}
                    </pre>
                  )}
                </div>
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
